import { FunctionComponent } from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';

export const SectionLabelTypography: FunctionComponent<TypographyProps<'span'>> = (props) => {
  return (
    <Typography
      component={'span'}
      variant={'body2'}
      noWrap={true}
      {...props}
      sx={[{
        textTransform: 'uppercase',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]} />
  );
};
